// NotFound.jsx
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

export default function NotFound() {
  return (
    <div className="min-h-screen w-full bg-[#FFF8E1] text-[#2F2F2F] flex flex-col items-center justify-center px-6 py-12">
      <div className="text-center max-w-xl">
        <h1 className="text-7xl font-extrabold text-[#B8860B] mb-4">404</h1>
        <h2 className="text-3xl font-semibold mb-4">Page Not Found</h2>
        <p className="text-lg text-gray-700 mb-6">
          The page you're looking for isn't available. It may have been moved, removed, or never existed.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-[#B8860B] hover:bg-[#A1760A] text-white px-6 py-3 rounded-xl text-sm font-medium transition"
        >
          <FaArrowLeft size={14} />
          Return to Home
        </Link>
      </div>

      <div className="mt-12 text-center max-w-2xl">
        <h3 className="text-xl font-bold text-[#2F2F2F] mb-2">
          Anil Dhyani & Associates
        </h3>
        <p className="text-gray-800 leading-relaxed text-sm">
          With over <strong>30 years of experience</strong>, we provide unparalleled legal solutions with integrity and precision.
          Let us guide you through the complexities of law with expertise and dedication.
        </p>
      </div>
    </div>
  );
}
